import React from "react";
import { Box, Chip, Tooltip, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
//import connectimg from "../assets/imgs/favicon (3).png";
import connectimg from "../../assets/imgs/favicon (3).png";
const CareerTalkBadge = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isTabletOrSmaller = useMediaQuery(theme.breakpoints.down("md"));

  const handleCareerTalkNavigation = () => {
    // Navigate to the route and pass the tab index as state
    navigate("/tech-camp-calendar", { 
      state: { activeTab: 4 } // Career Talk tab is at index 4
    });
  };


  return (
    <Tooltip title="Career Talk">
      <Box
        sx={{
          position: "relative",
          mr: 2,
          "&::before": {
            content: '""',
            position: "absolute",
            top: "-2px",
            left: "-2px",
            right: "-2px",
            bottom: "-2px",
            background:
              "linear-gradient(45deg, #4CAF50, #1E88E5, #4CAF50, #1E88E5)",
            backgroundSize: "300% 300%",
            borderRadius: isTabletOrSmaller ? "50%" : "18px",
            zIndex: -1,
            animation: "gradient-shift 3s ease infinite",
          },

          "@keyframes gradient-shift": {
            "0%": { backgroundPosition: "0% 50%" },
            "50%": { backgroundPosition: "100% 50%" },
            "100%": { backgroundPosition: "0% 50%" },
          },
          "@keyframes pulse-glow": {
            "0%": {
              boxShadow: "0 4px 12px rgba(30, 136, 229, 0.3)",
              transform: "scale(1)",
            },
            "50%": {
              boxShadow: "0 6px 20px rgba(30, 136, 229, 0.6)",
              transform: "scale(1.02)",
            },
            "100%": {
              boxShadow: "0 4px 12px rgba(30, 136, 229, 0.3)",
              transform: "scale(1)",
            },
          },
          "@keyframes bounce-icon": {
            "0%, 100%": { transform: "translateY(0px) rotate(0deg)" },
            "25%": { transform: "translateY(-2px) rotate(-2deg)" },
            "75%": { transform: "translateY(-1px) rotate(2deg)" },
          },
          "@keyframes shimmer": {
            "0%": { transform: "translateX(-100%)" },
            "100%": { transform: "translateX(100%)" },
          },
        }}
      >
        {isTabletOrSmaller ? (
          // Icon only for small screens
          <Box
            onClick={handleCareerTalkNavigation}
            sx={{
              position: "relative",
              overflow: "hidden",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 40,
              height: 40,
              borderRadius: "50%",
              background: "linear-gradient(135deg, #4CAF50 0%, #1E88E5 100%)",
              color: "#FFFFFF",
              cursor: "pointer",
              boxShadow: "0 4px 12px rgba(30, 136, 229, 0.3)",
              transition: "all 0.3s ease",
              animation: "pulse-glow 3s ease-in-out infinite",
              "&::after": {
                content: '""',
                position: "absolute",
                top: 0,
                left: "-100%",
                width: "100%",
                height: "100%",
                background:
                  "linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent)",
                animation: "shimmer 2.5s ease-in-out infinite",
              },
              "&:hover": {
                background: "linear-gradient(135deg, #1E88E5 0%, #4CAF50 100%)",
                transform: "translateY(-3px) scale(1.1)",
                boxShadow: "0 8px 25px rgba(30, 136, 229, 0.5)",
                animation: "none",
                "& img": {
                  animation: "bounce-icon 0.6s ease-in-out infinite",
                },
                "&::after": {
                  animation: "shimmer 1s ease-in-out infinite",
                },
              },
            }}
          >
            <img
              src={connectimg}
              alt="Career Talk"
              style={{
                width: 22,
                height: 22,
                objectFit: "contain",
                filter: "brightness(0) invert(1)",
                animation: "bounce-icon 2s ease-in-out infinite",
              }}
            />
          </Box>
        ) : (
          // Full Chip for larger screens
          <Chip
            // icon={
            //   <img
            //     src={connectimg}
            //     alt="Career"
            //     style={{
            //       width: 18,
            //       height: 18,
            //       objectFit: "contain",
            //       filter: "brightness(0) invert(1)",
            //       animation: "bounce-icon 2s ease-in-out infinite",
            //     }}
            //   />
            // }
            label="Career Talk"
            onClick={handleCareerTalkNavigation}
            sx={{
              position: "relative",
              overflow: "hidden",
              background: "linear-gradient(135deg, #4CAF50 0%, #1E88E5 100%)",
              color: "#FFFFFF",
              fontSize: "0.8rem",
              fontWeight: 600,
              height: 32,
              cursor: "pointer",
              borderRadius: "16px",
              boxShadow: "0 4px 12px rgba(30, 136, 229, 0.3)",
              transition: "all 0.3s ease",
              animation: "pulse-glow 3s ease-in-out infinite",
              "&::after": {
                content: '""',
                position: "absolute",
                top: 0,
                left: "-100%",
                width: "100%",
                height: "100%",
                background:
                  "linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent)",
                animation: "shimmer 2.5s ease-in-out infinite",
              },
              "&:hover": {
                background: "linear-gradient(135deg, #1E88E5 0%, #4CAF50 100%)",
                transform: "translateY(-3px) scale(1.05)",
                boxShadow: "0 8px 25px rgba(30, 136, 229, 0.5)",
                animation: "none",
                "& img": {
                  animation: "bounce-icon 0.6s ease-in-out infinite",
                },
                "&::after": {
                  animation: "shimmer 1s ease-in-out infinite",
                },
              },
            }}
          />
        )}
      </Box>
    </Tooltip>
  );
};

export default CareerTalkBadge;
